const tables = [
  {
    name: "Name",
  },
  {
    name: "Created By",
  },
  {
    name: "Action",
  },
];

export default tables;
